import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import Divider from "@material-ui/core/Divider";
import { Card, Button, Modal } from "react-bootstrap";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import "../../../../utils/Css/Marketing.css";
import "../../../../utils/Css/Campagne.css";
import Datetime from "react-datetime";

import campagneReseauxSociauxService from "./../../../../services/MarketingService/CampagneReseauxSociauxService"
import getCurrentUserId from './../../../../reduxSaga/sagas/requests/currentUserId';


function TableCampagneR() {
  const [data, setData] = useState([]);

  const [piecesJointesdata, setPiecesJointesdata] = useState([]);
  const [typesData, setTypesData] = useState([]);
  const [canalDiffusionsData, setCanalDiffusionsData] = useState([]);
  const [objectifsData, setObjectifsData] = useState([]);
  const [statutsData, setStatutsData] = useState([]);

  const [selectedCampagne, setSelectedCampagne] = useState(null);
  const [publicationDate, setpublicationDate] = useState(null);

  const [inputValue, setInputValue] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [success, setSuccess] = useState(null);
  const [erreur, setErreur] = useState(null);

  // state for filter parameters
  const [filter, setFilter] = useState({
    nom: "",
    canalDiffusion: "",
    type: "",
    statut: "",
    startDate: "",
    endDate: "",
  });

  const handleExportCSVBackend = async () => {
    try {
      // Création d'un tableau pour stocker les données filtrées
      const filteredData = data.map(
        (item) => `${item.nom},${item.type},${item.canalDiffusion}`
      );
      // Appel à l'API Spring Boot pour récupérer les données filtrées
      const response = await campagneReseauxSociauxService.Exportcsv(
        filteredData
      );

      // Création du contenu du fichier CSV

      const csvContent = `data:text/csv;charset=utf-8,${response.data}`;

      // Création d'un élément d'ancrage invisible pour télécharger le fichier
      const downloadLink = document.createElement("a");
      downloadLink.href = encodeURI(csvContent);
      downloadLink.download = "filtered_data.csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error(error);
    }
  };

  // Fonction pour exporter les données filtrées au format CSV
  const handleExportCSV = () => {
    const currentDateTime = new Date().toISOString().replace(/[-:.]/g, "");
    const headerValue = "Nom,Type,Canal de diffusion";
    const csvData = data.map(
      (item) => `${item.nom},${item.type},${item.canalDiffusion}`
    );
    const csvContent = `${headerValue}\n${csvData.join("\n")}`;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Campagne_Reseaux_Sociaux_${currentDateTime}.csv`;
    link.click();
  };

  //Delete modal
  // Gérer les changements de valeur dans l'entrée
  const handleInputChangeDelete = (event) => {
    setInputValue(event.target.value);

    // Désactiver le bouton de suppression si l'entrée est vide ou différente de "DELETE"
    if (event.target.value !== "DELETE") {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };
  //DeleteModal
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleClose = () => setShow(false);

  const handleDeleteCampagne = (row) => {
    setSelectedRow(row);
    setShow(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await campagneReseauxSociauxService.supprimerCampagneReseauxSociaux(
        selectedRow.id
      );
      const newData = data.filter((item) => item.id !== selectedRow.id);
      setData(newData);
      setShow(false);
      // Effacer la valeur de l'input "DELETE" après le clique sur le button supprimer
      setInputValue("");
    } catch (error) {
      console.error(error);
    }
  };

  //EditModal
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    nom: "",
    objectif: "",
    contenu: "",
    canalDiffusion: "",
    type: "",
    cible: "",
    publicationDate: "",
    PiecesJoints: "",
  });
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //date
  const handleDateChange = (date) => {
    setpublicationDate(date);
    setFormData({ ...formData, publicationDate: date });
  };

  // Gérer la sélection de fichiers joints
  const handlePieceJointeChange = (event) => {
    setPiecesJointesdata([...piecesJointesdata, event.target.files[0]]);
  };

  // Supprimer le dernier fichier joint de la liste
  const handleDeletePieceJointe = () => {
    // Create a copy of the piecesJointesdata array
    const newPiecesJointesData = [...piecesJointesdata];

    // Remove the last item from the array
    newPiecesJointesData.pop();

    // Update the state with the new array
    setPiecesJointesdata(newPiecesJointesData);
  };

  // Gérer l'édition de la Campagne
  const handleEditCampagne = (campagne) => {
    setSelectedCampagne(campagne);
    setShowModal(true);
    setFormData({
      nom: campagne.nom,
      objectif: campagne.objectif,
      contenu: campagne.contenu,
      canalDiffusion: campagne.canalDiffusion,
      type: campagne.type,
      cible: campagne.cible,
      publicationDate: campagne.publicationDate,
      PiecesJoints: campagne.PiecesJoints,
    });
  };

  // Gérer la soumission du formulaire d'édition de la campagne
  const handleUpdateCampagne = async (event) => {
    event.preventDefault();

    const {
      nom,
      contenu,
      canalDiffusion,
      type,
      cible,
      objectif,
      publicationDate,
      PiecesJoints,
    } = formData;

    if (nom === selectedCampagne.nom && contenu === selectedCampagne.contenu) {
      // Vérifier si les champs ont été modifiés
      setErreur(
        "Veuillez modifier au moins un champ avant de soumettre le formulaire."
      );
      return;
    }

    const updatedCampagne = { ...formData };
    if (!nom) {
      // Vérifier si le nom et le prénom sont renseignés
      setErreur("Veuillez renseigner tous les champs.");
      return;
    }

    // Mettre à jour la Campagne avec les nouvelles informations et les images
    const images = piecesJointesdata ? piecesJointesdata : null;
    campagneReseauxSociauxService
      .mettreAJourCampagneReseauxSociaux(
        updatedCampagne,
        images,
        selectedCampagne.id
      )
      .then(() => {
        const updatedData = data.map((campagne) =>
          campagne.id === selectedCampagne.id
            ? { ...campagne, ...updatedCampagne }
            : campagne
        );
        setData(updatedData);
        setShowModal(false);
        setSelectedCampagne(null);
        setPiecesJointesdata([]);

        setSuccess("Modification validée avec succès !");
      });
  };
  const handleCancel = () => {
    setShowModal(false);
    setSelectedCampagne(null);
  };

  //useEffect
  useEffect(() => {
    AfficherListTypes();
    AfficherListCanalDiffusion();
    AfficherListObjectifs();
    AfficherListStatus();
    fetchData();
  }, []);
  useEffect(() => {
    if (success) {
      const timeoutId = setTimeout(() => {
        setSuccess(null);
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
    /* if (erreur) {
      const timeoutId = setTimeout(() => {
        setErreur(null);
      }, 2000);
      return () => clearTimeout(timeoutId);
    } */
  }, [success]);

  //methode pour afficher objectifs
  const AfficherListObjectifs = async () => {
    try {
      campagneReseauxSociauxService.AfficherListObjectifs().then((response) => {
        setObjectifsData(response.data.success);

      }).catch((error) => {
        console.log("error", error);
      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  //methode pour afficher status
  const AfficherListStatus = async () => {
    try {
      campagneReseauxSociauxService.AfficherListStatus().then((response) => {
        setStatutsData(response.data.success);
      }).catch((error) => {
        console.log("error", error);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  //methode pour afficher types
  const AfficherListTypes = async () => {
    try {
      campagneReseauxSociauxService.AfficherListTypes().then((response) => {
        setTypesData(response.data.success);
      }).catch((error) => {
        console.log("error", error);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //methode pour afficher Canal de Diffusions
  const AfficherListCanalDiffusion = () => {
    try {
      campagneReseauxSociauxService.AfficherListCanalDiffusion().then((response) => {
        setCanalDiffusionsData(response.data.success);

      }).catch((error) => {
        console.log("error", error);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  const fetchData = async () => {
    try {
      campagneReseauxSociauxService.AfficherListCampagneReseauxSociaux(getCurrentUserId()).then((response) => {
        setData(response.data.success);

      }).catch((error) => {
        console.log("error", error);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  //pagination
  const options = {
    sizePerPage: 4,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  //filtre
  // update filter parameters on change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  //filtre par date

  // cancel date range filter
  const handleCancelDateRange = () => {
    setFilter((prevState) => ({
      ...prevState,
      startDate: "",
      endDate: "",
    }));
  };
  // update filter on date range change
  const handleDateRangeChange = (event, picker) => {
    setFilter((prevState) => ({
      ...prevState,
      startDate: picker.startDate.format("YYYY-MM-DD"),
      endDate: picker.endDate.format("YYYY-MM-DD"),
    }));
  };
  // filter data
  const filterData = async () => {
    // try {
    //   const response =
    //     await campagneReseauxSociauxService.getCampagneReseauxSociauxByFiltre(
    //       filter.nom,
    //       filter.canalDiffusion,
    //       filter.type,
    //       filter.statut,
    //       filter.startDate,
    //       filter.endDate
    //     );
    //   setData(response.data);
    // } catch (error) {
    //   console.log(error);
    //   setErreur(error.message);
    // }
  };

  // useEffect to fetch data based on filter parameters
  useEffect(() => {
    if (filter) {
      filterData();
    } else {
      fetchData();
    }
  }, [filter]);

  //routes
  const navigate = useNavigate();

  // columns-Campagne
  const columns = [
    {
      dataField: "creationDate",
      text: "Date creation",
      formatter: (cell) => {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const date = new Date(cell);
        return date.toLocaleDateString("fr-FR", options).replace(/\//g, "-");
      },
    },
    {
      dataField: "publicationDate",
      text: "Date publication",
      formatter: (cell) => {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const date = new Date(cell);
        return date.toLocaleDateString("fr-FR", options).replace(/\//g, "-");
      },
    },
    {
      dataField: "nom",
      text: "Nom",
    },
    {
      dataField: "canalDiffusion",
      text: "Canal de diffusion",
    },
    {
      dataField: "objectif",
      text: "Objectif",
    },
    {
      dataField: "type",
      text: "Type",
    },
    {
      dataField: "statut",
      text: "Statut",
      formatter: (cellContent, row) => {
        if (row && row.statut === "terminé") {
          return <span className="badge badge-danger">{cellContent}</span>;
        } else {
          return <span className="badge badge-success">{cellContent}</span>;
        }
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <>
            <div className="d-flex justify-content-center">
              <Button
                variant="secondary"
                className="mr-2"
                onClick={() => handleEditCampagne(row)}
              >
                <i className="fas fa-edit"></i>
              </Button>{" "}
              <Button
                variant="dark"
                className="mr-2"
                onClick={() => handleDeleteCampagne(row)}
              >
                <i className="fas fa-trash"></i>
              </Button>{" "}
              <Button
                variant="secondary"
                onClick={() =>
                  navigate(`/Campagne/PageCampagneR/Voir/${row.id}`)
                }
              >
                <i className="fas fa-chart-pie"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  // /.columns-Campagne


  return (
    <>
      <div className="row mt-2">
        <div className="col-md-12">
          <div className="card-deck">
            <Card className="Campagne-card-filter">
              <Card.Body>
                <div className="row">
                  <div className="col-lg-3 col-6">
                    <label>Date</label>
                    <div className="input-group date mt-2">
                      <DateRangePicker
                        className="input-group date"
                        startDatePlaceholder="Start Date"
                        endDatePlaceholder="End Date"
                        onApply={handleDateRangeChange}
                      >
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <FontAwesomeIcon icon={faCalendarAlt} />
                            </span>
                          </div>
                          <input
                            type="text"
                            className="form-control datetimepicker-input"
                            value={
                              filter.startDate && filter.endDate
                                ? `${filter.startDate} - ${filter.endDate}`
                                : ""
                            } />
                          {filter.startDate && filter.endDate && (
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  onClick={handleCancelDateRange}
                                />
                              </span>
                            </div>
                          )}
                        </div>
                      </DateRangePicker>
                    </div>
                  </div>
                  {/* filtre par select contenu*/}
                  <div className="col-lg-3 col-6">
                    <div className="form-group">
                      <label>Canal de diffusion</label>
                      <select
                        className="custom-select mt-2"
                        name="canalDiffusion"
                        value={filter.canalDiffusion}
                        onChange={handleFilterChange}
                      >
                        <option value="">All</option>
                        {canalDiffusionsData.map((canalDiffusion) => (
                          <option key={canalDiffusion} value={canalDiffusion}>
                            {canalDiffusion}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* /.filtre par select contenu*/}
                  {/* filtre par statut*/}
                  <div className="col-lg-3 col-6">
                    <div className="form-group">
                      <label>Type</label>
                      <select
                        className="custom-select mt-2"
                        name="type"
                        value={filter.type}
                        onChange={handleFilterChange}
                      >
                        <option value="">All</option>
                        {typesData.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* /.filtre par statut*/}
                  {/* filtre par statut*/}
                  <div className="col-lg-3 col-6">
                    <div className="form-group">
                      <label>Statut</label>
                      <select
                        className="custom-select mt-2"
                        name="statut"
                        value={filter.statut}
                        onChange={handleFilterChange}
                      >
                        <option value="">All</option>
                        {statutsData.map((statut) => (
                          <option key={statut} value={statut}>
                            {statut}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* /.filtre par statut*/}
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
      {/* /.filtre */}

      {/* table */}
      <Divider />
      <ToolkitProvider>
        {(props) => (
          <>
            <div className="row mt-2">
              <div className="col-md-12">
                <Card className="pb-3">
                  <Card.Body>
                    {/* table-button */}
                    <div className="d-flex justify-content-end align-items-center mb-2">
                      <div className="input-container">
                        {/* SearchData */}
                        <div className="p-2">
                          <div className="input-group">
                            <input
                              className="form-control "
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              name="nom"
                              value={filter.nom}
                              onChange={handleFilterChange}
                            />
                          </div>
                        </div>

                        {/* /.SearchData */}
                        {/* ExportCSV button */}
                        <div className="p-2">
                          <Button
                            onClick={handleExportCSV}
                            variant="dark"
                            className="my-custom-class Exporter input-container"
                          >
                            Exporter CSV
                          </Button>
                        </div>
                        {/* /.ExportCSV button */}

                        {/* Ajouter button */}
                        <div className="p-2">
                          <Button
                            className="my-custom-class Ajouter input-container"
                            variant="secondary"
                            onClick={() =>
                              navigate("/Campagne/PageCampagneR/AddCampagneR")
                            }
                          >
                            Ajouter
                          </Button>
                        </div>
                        {/* /.Ajouter button */}
                      </div>
                    </div>
                    {/* /.table-button */}
                    <div className="table-container thead-dark mb-3">
                      <BootstrapTable
                        keyField="id"
                        hover
                        condensed
                        pagination={paginationFactory(options)}
                        noDataIndication={() => "No data found"}
                        data={data}
                        columns={columns}
                        headerClasses="thead-dark"
                      />
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
            {/* /.table */}
          </>
        )}
      </ToolkitProvider>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Confirmation de suppression</Modal.Title>
          <button className="close">
            <FontAwesomeIcon icon={faTimes} closeButton onClick={handleClose} />
          </button>
        </Modal.Header>
        <Modal.Body>
          Êtes-vous sûr(e) de vouloir supprimer ?<br />
          <br />
          <strong>Date de creation : </strong>
          {selectedRow && selectedRow.createdDate && (
            <>
              {new Date(selectedRow.createdDate)
                .toLocaleDateString("fr-FR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
                .replace(/\//g, "-")}
            </>
          )}
          <br />
          <strong>Nom : </strong>
          {selectedRow && selectedRow.nom}
          <br />
          <br />
          <br />
          <p>
            Tapper le mot <strong>DELETE</strong> pour pouvez supprimer Data
          </p>
          <input
            type="text"
            className="form-control"
            placeholder="DELETE"
            value={inputValue}
            onChange={handleInputChangeDelete}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirmDelete}
            disabled={buttonDisabled}
          >
            Supprimer
          </Button>
        </Modal.Footer>
      </Modal>
      {/* /.DeleteModal */}
      {/* EditEventModal */}
      <Modal
        show={showModal}
        onHide={handleCancel}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div
          className="card card-dark"
          style={{ boxShadow: "none", marginBottom: 0 }}
        >
          <div className="card-header">
            <h3 className="card-title">Modifier Campagne</h3>
            <button className="close">
              <FontAwesomeIcon
                icon={faTimes}
                closeButton
                onClick={handleCancel}
                style={{ color: "white" }}
              />
            </button>
          </div>
          <form>
            <div className="card-body">
              {erreur && (
                <div className="alert alert-danger" role="alert">
                  {erreur}
                </div>
              )}

              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Nom</label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  placeholder="Nom"
                  name="nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Objectif</label>
                <select
                  className="custom-select"
                  id="objectif"
                  name="objectif"
                  value={formData.objectif}
                  onChange={handleInputChange}
                >
                  {objectifsData.map((objectif) => (
                    <option key={objectif} value={objectif}>
                      {objectif}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">
                      Canal de diffusion
                    </label>
                    <select
                      className="custom-select"
                      id="canalDiffusion"
                      name="canalDiffusion"
                      value={formData.canalDiffusion}
                      onChange={handleInputChange}
                    >
                      {canalDiffusionsData.map((canalDiffusion) => (
                        <option key={canalDiffusion} value={canalDiffusion}>
                          {canalDiffusion}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Type</label>
                    <select
                      className="custom-select"
                      id="type"
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                    >
                      {typesData.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Contenu</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Contenu ..."
                  name="contenu"
                  value={formData.contenu}
                  onChange={handleInputChange}
                ></textarea>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Cible</label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Cible"
                      name="cible"
                      value={formData.cible}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1">
                        Date Publication
                      </label>
                      <Datetime
                        onChange={handleDateChange}
                        value={formData.publicationDate}
                        name="publicationDate"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="pieces-jointes">Pieces jointes</label>
                <div className="input-group">
                  <div className="custom-file">
                    <input
                      type="file"
                      className="custom-file-input"
                      id="PiecesJoints"
                      name="PiecesJoints"
                      onChange={handlePieceJointeChange}
                      value={formData.PiecesJoints}
                    />
                    <label
                      className="custom-file-label"
                      htmlFor="pieces-jointes"
                    >
                      {piecesJointesdata.length === 0
                        ? "Choose file"
                        : piecesJointesdata
                          .map((fichier) => fichier.name)
                          .join(", ")}
                    </label>
                  </div>
                  {piecesJointesdata.length > 0 && (
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleDeletePieceJointe}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  )}
                </div>
                {/* affichage des images  */}
                <div className="row mt-3">
                  {piecesJointesdata.map((fichier, index) => (
                    <div key={index} className="col-sm-3 text-center mb-3">
                      <img
                        src={URL.createObjectURL(fichier)}
                        alt={fichier.name}
                        style={{ width: "100%", height: "80%" }}
                      />
                      <button
                        className="btn btn-outline-danger col-sm mt-3 mb-3"
                        type="button"
                        onClick={() => handleDeletePieceJointe(index)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  ))}
                </div>
                {/* end of affichage des images  */}
              </div>
            </div>
          </form>
        </div>
        <div className="card-footer text-right">
          <button
            type="button"
            className="btn btn-secondary mr-2"
            onClick={handleCancel}
          >
            Annuler
          </button>
          <button
            type="submit"
            className="btn btn-dark"
            onClick={handleUpdateCampagne}
          >
            Modifier
          </button>
        </div>
      </Modal>
    </>
  );
}

export default TableCampagneR;
